import {
  PiBrainDuotone,
  PiChartBarDuotone,
  PiFilePdfDuotone,
  PiGameControllerDuotone,
  PiGaugeDuotone,
  PiHouseDuotone,
  PiLightbulbDuotone,
  PiPulseDuotone,
  PiSquaresFourDuotone,
  PiUserPlusDuotone,
} from 'react-icons/pi'
import { users } from '../utils/users'

export const links = [
  {
    type: 'link',
    link: '/',
    title: 'Overview',
    icon: <PiHouseDuotone />,
  },
  {
    type: 'link',
    link: '/activities',
    title: 'Activities',
    icon: <PiGameControllerDuotone />,
  },

  { type: 'divider' },
  {
    type: 'link',
    link: '/dashboard',
    title: 'Brain',
    icon: <PiBrainDuotone />,
  },

  { type: 'divider' },
  { type: 'title', label: 'Reports' },
  {
    type: 'link',
    link: '/eeg-analytics',
    title: 'EEG Analytics',
    icon: <PiPulseDuotone />,
    access: [users.ajay],
  },
  {
    type: 'link',
    link: '/profile',
    title: 'EEG Report',
    icon: <PiFilePdfDuotone />,
  },
  {
    type: 'link',
    link: '/neuro-diagnosis',
    title: 'Neuro Diagnosis',
    icon: <PiGaugeDuotone />,
    access: [users.ajay, users.research],
  },

  { type: 'title', label: 'Bonus' },
  {
    type: 'link',
    link: '/recommendations',
    title: 'Recommendations',
    icon: <PiLightbulbDuotone />,
  },
  {
    type: 'link',
    link: '/session',
    title: 'Session Wise',
    icon: <PiSquaresFourDuotone />,
  },
  {
    type: 'link',
    link: '/aggregate',
    title: 'Aggregate',
    icon: <PiChartBarDuotone />,
  },

  { type: 'divider' },
  {
    type: 'link',
    link: '/children/add',
    title: 'Add User',
    icon: <PiUserPlusDuotone />,
  },
]
